const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M210,64.7c.4.2.9.3,1.3.5L152.1.4H42.9C23.5.4,7.8,15.9,7.8,34.9v186.3c0,19,15.8,34.4,35.1,34.4l96.9-.2c-19.8-5.8-27-18.1-27-18.1H42.9c-9,0-16.4-7.2-16.4-16.1V34.9c0-8.9,7.4-16.1,16.4-16.1h95.7v64.9s24.3.1,33.4,0c7-19.6,26.8-22.9,38-19ZM157.3,65.3v-31.7l28.9,31.7h-28.9Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,101.1c0-5.3-4-9.6-9-9.6H44.6c-4.9,0-9,4.3-9,9.6s4,9.6,9,9.6h83c4.9,0,9-4.3,9-9.6Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9,145.7c0-5.3-2.4-9.6-5.4-9.6h-49.8c-3,0-5.4,4.3-5.4,9.6s2.4,9.6,5.4,9.6h49.8c3,0,5.4-4.3,5.4-9.6Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,184.9c-2.4,0-4.4,4.3-4.4,9.6s1.9,9.6,4.4,9.6h40.3c2.4,0,4.4-4.3,4.4-9.6s-1.9-9.6-4.4-9.6h-40.3Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1,243.9l14.7,8,26.5-17.1-44.2-23.1,2.9,32.1h.1ZM243.1,92.3l-42.2-22.1c-7.8-4-17.7-1-22.6,7l-7.8,15.1,71.6,37.1,7.8-15.1c4.9-8,1-18.1-6.9-22.1h0ZM186.2,110.4l-18.6-9c-11.8,25.1-24.5,49.2-36.3,74.3,2,10,5.9,15.1,14.7,12l25.5-50.2,4.9,2-25.5,49.2c6.9,14.1,18.6,17.1,32.4,15.1,2,11,6.9,17.1,18.6,10l36.3-74.3-18.6-10-33.4-19.1h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileEdit);
export default __webpack_public_path__ + "static/media/file-edit.6d37ddb7cc34f7ddea48f342e8f15951.svg";
export { ForwardRef as ReactComponent };